import script from "./Wall6View.vue?vue&type=script&setup=true&lang=js"
export * from "./Wall6View.vue?vue&type=script&setup=true&lang=js"

import "./Wall6View.vue?vue&type=style&index=0&id=1717c31e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1717c31e"]])

export default __exports__